import { useState } from 'react';
import { Modal } from '@iwoca/orion';
import { ButtonLink } from 'components/ButtonLink/ButtonLink';
import { useOffers } from 'components/Signup/hooks/useOffers';
import { ShareRequirements } from '../ShareRequirements/ShareRequirements';
import styles from './DocumentUploadInfo.module.css';

export const DocumentUploadInfo = () => {
  const [showDocumentRequestModal, setShowDocumentRequestModal] =
    useState(false);

  const { documentRequirements } = useOffers({ getOffersEnabled: true });

  const optionalDocs = (documentRequirements || []).filter(
    (document) => document.is_optional,
  );

  const requiredDocs = (documentRequirements || [])?.filter(
    (document) => !document.is_optional,
  );

  return (
    <>
      <div>
        To proceed with this offer, we need a few more details. Don’t have them?{' '}
        <ButtonLink inline onClick={() => setShowDocumentRequestModal(true)}>
          Send a request to your client.
        </ButtonLink>
      </div>

      <Modal
        headerBar
        closeIcon
        className={styles.container}
        isOpen={showDocumentRequestModal}
        onClose={() => setShowDocumentRequestModal(false)}
        title="Need to ask the applicant for these documents?"
      >
        <ShareRequirements
          optionalDocs={optionalDocs}
          requiredDocs={requiredDocs}
        />
      </Modal>
    </>
  );
};
